import { dashboardConstants } from "../_constants";

const {
  GET_ALL_TERMINAL_SUMMARY_START,
  GET_ALL_TERMINAL_SUMMARY_SUCCESS,
  GET_ALL_TERMINAL_SUMMARY_FAILED,
  FILTER_TERMINAL_SUMMARY_FAILED,
  FILTER_TERMINAL_SUMMARY_SUCCESS,
  FILTER_TERMINAL_SUMMARY_START,
  // GET_TOTAL_REGISTRATION_COUNT_SUMMARY_START,
  // GET_TOTAL_REGISTRATION_COUNT_SUMMARY_FAILED,
  // GET_TOTAL_REGISTRATION_COUNT_SUMMARY_SUCCESS,
  // FILTER_TERMINAL_SUMMARY_COUNT_START,
  // FILTER_TERMINAL_SUMMARY_COUNT_SUCCESS,
  // FILTER_TERMINAL_SUMMARY_COUNT_FAILED
} = dashboardConstants;

const initialState = {
  terminalSummaryData: [],
  isLoading: false,
  error: false,
  summaryCount: 0,
  summarySuccess: 0,
  summaryFailed: 0,
  summaryPending: 0,
  filteredTerminalSummary: [],
  // countSummary: {},
  // filteredCountSummary: {}
};

const DashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_TERMINAL_SUMMARY_START:
      return {
        ...state,
        isLoading: true,
      };
    case GET_ALL_TERMINAL_SUMMARY_SUCCESS:
      const { content, count, success, failed, pending } = payload;
      return {
        ...state,
        isLoading: false,
        terminalSummaryData: content,
        summaryCount: count,
        summarySuccess: success,
        summaryFailed: failed,
        summaryPending: pending
      };
    case GET_ALL_TERMINAL_SUMMARY_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case FILTER_TERMINAL_SUMMARY_START:
      return { ...state, isLoading: true };
    case FILTER_TERMINAL_SUMMARY_SUCCESS:
      const { content: filteredTerminalSummary, count: filteredSummaryCount, success: filteredSuccess, failed: filteredFailed, pending: filteredPending } =
        payload;
      return {
        ...state,
        isLoading: false,
        terminalSummaryData: filteredTerminalSummary,
        summaryCount: filteredSummaryCount,
        summarySuccess: filteredSuccess,
        summaryFailed: filteredFailed,
        summaryPending: filteredPending
      };
    case FILTER_TERMINAL_SUMMARY_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
      // case GET_TOTAL_REGISTRATION_COUNT_SUMMARY_START:
      //   return {
      //     ...state,
      //     isLoading: true
      //   }
      // case GET_TOTAL_REGISTRATION_COUNT_SUMMARY_SUCCESS:
      //   // const {successfulCount, failedCount, pendingCount} = payload;
      //   return {
      //     ...state,
      //     isLoading: false,
      //     countSummary: {...payload}
      //   }
      //   case GET_TOTAL_REGISTRATION_COUNT_SUMMARY_FAILED:
      //     return {
      //       ...state,
      //       isLoading: false,
      //       error: payload,
      //     };
      // case FILTER_TERMINAL_SUMMARY_COUNT_START:
      //   return { ...state, isLoading: true };
      // case FILTER_TERMINAL_SUMMARY_COUNT_SUCCESS:
      //   const {successfulCount: filteredSuccessfulCount, failedCount: filteredFailedCount, pendingCount: filteredPendingCount } = payload;
      //   return {
      //     ...state,
      //     isLoading: false,
      //     countSummary: {...payload}
      //   }
    default:
      return state;
  }
};

export default DashboardReducer;
